export const getExtensionStyles = (extension: string) => {
	const styles = {
		TIF: {
			backgroundColor: "#F8CECC",
			borderColor: "rgba(255, 0, 0, 0.5)",
		},
		DWG: {
			backgroundColor: "#FFF2CC",
			borderColor: "rgba(255, 255, 0, 0.5)",
		},
		CAL: {
			backgroundColor: "#D5E8D4",
			borderColor: "rgba(0, 128, 0, 0.5)",
		},
		PDF: {
			backgroundColor: "#E1D5E7",
			borderColor: "rgba(128, 0, 128, 0.5)",
		},
	};

	return (
		styles[extension as keyof typeof styles] || {
			backgroundColor: "#DAE8FC",
			borderColor: "rgba(0, 0, 255, 0.5)",
		}
	);
};
